import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { axiosInstance } from '../api/http'
import { useRecoilValue } from 'recoil'
import { userIdAtom } from '../state/state'

export const useContentCount = () => {
  const userId = useRecoilValue(userIdAtom)

  const storeKey = useMemo(() => ['user', userId, 'content-count'], [userId])

  return useQuery(storeKey, axiosInstance.mobile.contentControllerGetFinishedContentCountForUserByContentType, {
    enabled: !!userId,
    select: ({ data }) => data.payload,
  })
}
